import * as React from 'react';
import styled from '@emotion/styled';
import { lighten, transparentize } from 'polished';
import { FaChevronDown } from 'react-icons/fa';
import { Label } from './field';
const Wrapper = styled.div `
  position: relative;
`;
const Select = styled.button `
  cursor: pointer;
  position: relative;
  background: none;
  border: 1px solid ${(props) => lighten(0.5, props.theme.primaryColour)};
  border-radius: 3px;
  padding: 0.5rem;
  padding-right: 1.5rem;

  div {
    white-space: nowrap;
  }
`;
const Arrow = styled.div `
  position: absolute;
  top: 0;
  bottom: 0;
  height: 100%;
  width: 14px;
  right: 4px;
  color: #737373;
  svg {
    height: 100%;
    font-size: 0.75rem;
  }
`;
const Dropdown = styled.div `
  display: ${(props) => (props.visible ? 'block' : 'none')};
  position: absolute;
  right: ${(props) => (props.leftAlign ? `auto` : `0`)};
  top: 110%;
  height: 200px;
  z-index: 10;
  background-color: #fff;
  border-radius: 0 0 3px 3px;
  box-shadow: 1px 1px 1px 0 ${(props) => transparentize(0.8, props.theme.primaryColour)};
  overflow: hidden;
`;
const Scroll = styled.div `
  position: relative;
  height: 100%;
  overflow-y: auto;
`;
const Option = styled.button `
  display: block;
  cursor: pointer;
  background: none;
  border: 0;
  padding: 0.5rem;
  padding-right: 14px;
  width: 100%;
  &:hover {
    background: rgba(200, 200, 200, 0.2);
  }

  div {
    text-align: left;
    white-space: nowrap;
  }
`;
const DefaultRender = (v) => React.createElement("div", null, v);
export const Selectorator = ({ name, list, selected, select, render: renderIn, label, leftAlign = false, }) => {
    const [dropped, setDropped] = React.useState(false);
    const render = renderIn || DefaultRender;
    return (React.createElement(Wrapper, null,
        label && React.createElement(Label, { htmlFor: name }, label),
        React.createElement(Select, { id: name, name: name, type: "button", onClick: () => setDropped(!dropped), onBlur: () => {
                setTimeout(() => setDropped(false), 100);
            } },
            render(selected),
            React.createElement(Arrow, null,
                React.createElement(FaChevronDown, null))),
        React.createElement(Dropdown, { visible: dropped, leftAlign: leftAlign },
            React.createElement(Scroll, null, list.map((item, index) => (React.createElement(Option, { key: index, type: "button", id: `${name}-option-${index}`, name: `${name}-option-${index}`, onClick: () => {
                    select(item);
                    setDropped(false);
                } }, render(item))))))));
};
//# sourceMappingURL=selectorator.js.map